import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { CreateLink } from 'components/list';
import dataProvider from 'components/dataProvider';
import GridRadioButton from 'components/form/GridRadioButton';
import TitleLayout from '../layouts/sections/TitleLayout';
import ContractTable from './ContractTable';
import ManagementActTable from './ManagementActTable';

import './List.scss';

const ContractListInner = ({ rip }) => {
    const [selectedView, setSelectedView] = useState('contracts');

    return (
        <TitleLayout
            title="SOUSCRIPTION"
            className="title-layout"
        >
            {rip ? (
                <div>
                    <div className="container contract-mode-form">
                        <GridRadioButton
                            label="Contrats"
                            value="contracts"
                            name="viewSelector"
                            checked={'contracts' === selectedView}
                            onChange={() => setSelectedView('contracts')}
                        />
                        <GridRadioButton
                            label="Actes de gestion"
                            value="managementActs"
                            name="viewSelector"
                            checked={'managementActs' === selectedView}
                            onChange={() => setSelectedView('managementActs')}
                        />
                    </div>
                    {'contracts' === selectedView ? (
                        <ContractTable rip={rip} />
                    ) : (
                        <ManagementActTable rip={rip} />
                    )}
                    <CreateLink to={`/rip/${rip.id}/contracts/new`} />

                </div>
            ) : null}
        </TitleLayout>
    );
};

ContractListInner.propTypes = {
    rip: PropTypes.shape({
        id: PropTypes.string,
    }),
};

ContractListInner.defaultProps = {
    rip: null,
};

const ContractList = dataProvider({
    id: ({ params: { id } }) => id,
    type: 'rip',
    wait: true,
})(ContractListInner);

export default ContractList;
